import impactImage from '../assets/images/impact.jpg';
import facilityImage from '../assets/images/project_thumbnail_img_01.jpg';
import { stripHtmlTags } from '../utils';

const admissionsData = [
    {
        id: 1,
        heading: '1. Initial Assessment',
        description: 'Contact us for a confidential assessment. We gather necessary information to understand your needs.',
        content: '<p>Initial assessment is the first step...</p>',
        image: impactImage, 
        alt: 'Initial Assessment',
        slug: 'initial-assessment',
        date: new Date().toLocaleDateString(),
        category: 'Admission Step',
        index: 0
    },
    {
        id: 2,
        heading: '2. Insurance & Financial Review',
        description: 'We verify insurance coverage and discuss financial options to ensure a transparent process.',
        content: '<p>We accept most major insurance plans...</p>',
        image: impactImage,
        alt: 'Insurance Review',
        slug: 'insurance-review',
        date: new Date().toLocaleDateString(),
        category: 'Admission Step',
        index: 1
    },
    {
        id: 3,
        heading: '3. Admission & Orientation',
        description: 'Upon arrival, you will complete admission paperwork and receive a comprehensive orientation.',
        content: '<p>Orientation helps you settle in...</p>',
        image: impactImage,
        alt: 'Admission & Orientation',
        slug: 'admission-orientation',
        date: new Date().toLocaleDateString(),
        category: 'Admission Step',
        index: 2
    },
    {
        id: 4,
        heading: '4. Begin Treatment',
        description: 'Start your personalized treatment plan with our medical and clinical team.',
        content: '<p>Your recovery journey begins now...</p>',
        image: impactImage,
        alt: 'Begin Treatment',
        slug: 'begin-treatment',
        date: new Date().toLocaleDateString(),
        category: 'Admission Step',
        index: 3
    }
];

const facilityData = [
    {
        id: 1,
        heading: 'Private & Shared Rooms',
        description: 'Comfortable, clean, and safe accommodation designed to promote rest and recovery.',
        content: '<p>Our rooms are designed to provide a peaceful environment for rest and reflection.</p>',
        image: facilityImage,
        alt: 'Accommodations',
        slug: 'accommodations',
        date: new Date().toLocaleDateString(),
        category: 'Facility',
        index: 0
    },
    {
        id: 2,
        heading: 'Therapy Rooms',
        description: 'Private counseling rooms for confidential one-on-one sessions with our therapists.',
        content: '<p>Safe spaces for confidential therapy and counseling.</p>',
        image: facilityImage,
        alt: 'Therapy Rooms',
        slug: 'therapy-rooms',
        date: new Date().toLocaleDateString(),
        category: 'Facility',
        index: 1
    },
    {
        id: 3,
        heading: 'Recreational Areas',
        description: 'Spaces for physical activity, relaxation, and social interaction to support holistic well-being.',
        content: '<p>Recreation is a key part of recovery, helping to rebuild physical health and social skills.</p>',
        image: facilityImage,
        alt: 'Recreational Areas',
        slug: 'recreational-areas',
        date: new Date().toLocaleDateString(),
        category: 'Facility',
        index: 2
    },
    {
        id: 4,
        heading: 'Medical Clinic',
        description: 'On-site medical facility for detoxification, health monitoring, and emergency care.',
        content: '<p>Our on-site clinic ensures 24/7 medical supervision and care.</p>',
        image: facilityImage,
        alt: 'Medical Clinic',
        slug: 'medical-clinic',
        date: new Date().toLocaleDateString(),
        category: 'Facility',
        index: 3
    }
];

const toSlug = (value) => {
    return (value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
};

const toPlainText = (value) => {
    if (typeof value === 'string') {
        return stripHtmlTags(value).trim();
    }
    if (Array.isArray(value) && value.length > 0) {
        const first = value[0];
        if (typeof first === 'string') {
            return stripHtmlTags(first).trim();
        }
        if (first && typeof first.value === 'string') {
            return stripHtmlTags(first.value).trim();
        }
        if (first && typeof first.processed === 'string') {
            return stripHtmlTags(first.processed).trim();
        }
    }
    if (value && typeof value.value === 'string') {
        return stripHtmlTags(value.value).trim();
    }
    if (value && typeof value.processed === 'string') {
        return stripHtmlTags(value.processed).trim();
    }
    return '';
};

const mapImpactItem = (story, index) => {
    const title = toPlainText(story.title) || story.heading || story.title || 'Impact Story';
    const body = toPlainText(story.body) || toPlainText(story.content) || toPlainText(story.description);
    const description = toPlainText(story.description) || body || 'Impact story details coming soon.';
    return {
        id: story.nid?.[0]?.value || story.id || index + 1,
        heading: toPlainText(title) || 'Impact Story',
        description,
        content: body || description,
        image: story.field_image?.[0]?.url || story.image || '',
        alt: story.field_image?.[0]?.alt || story.alt || '',
        slug: story.slug || toSlug(title) || `impact-${index + 1}`,
        date: story.created?.[0]?.value || story.date || 'Recent',
        category: story.category || 'Impact',
        index
    };
};

const fetchImpactStories = async () => {
    const impactEndpoint = 'https://api.dmaimpact.org/rehab-impact-stories?_format=json';
    try {
        const response = await fetch(impactEndpoint);
        if (!response.ok) {
            return [];
        }
        const data = await response.json();
        if (!Array.isArray(data)) {
            return [];
        }
        const stories = data.map(mapImpactItem).filter(Boolean);
        return stories;
    } catch (error) {
        return [];
    }
};

export const fetchAllImpactStories = async (type) => {
    if (type === 'impact') {
        return fetchImpactStories();
    }
    if (type === 'facility') {
        return facilityData;
    }
    return admissionsData;
};

export const projectData = admissionsData;
